module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.el, {
    tag: "component",
    attrs: {
      "label": _vm.label,
      "prop": _vm.prop,
      "required": _vm.required
    }
  }, [(_vm.noForm) ? _c('div', [_vm._v(_vm._s(_vm.label) + " ")]) : _vm._e(), _vm._v(" "), _c('el-switch', {
    attrs: {
      "disabled": _vm.disabled,
      "size": _vm.size,
      "placeholder": _vm.placeholder,
      "active-color": _vm.onColor,
      "inactive-color": _vm.offColor,
      "active-text": _vm.isDesktop ? _vm.onText : null,
      "inactive-text": _vm.isDesktop ? _vm.offText : null,
      "active-close-icon": _vm.onIcon,
      "inactive-close-icon": _vm.offIcon
    },
    on: {
      "change": _vm.updated
    },
    model: {
      value: (_vm.formData),
      callback: function($$v) {
        _vm.formData = $$v
      },
      expression: "formData"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e94fc72"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/inputs/SwitchInput.vue
// module id = 1322
// module chunks = 0